import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import PxButton from "../../../../components/Buttons/PxButton";
import Body1Typo from "../../../../components/Typhography/Body1Typo";
import ButtonTypo from "../../../../components/Typhography/ButtonTypo";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../store";
import { applicationMeeting } from "../../../../actions/meeting";
import { useParams } from "react-router-dom";
import { MeetingApplicantDataInterface } from "../Meeting/MeetingDetail";
import {
  removeLoadingAction,
  setLoadingAction,
} from "../../../../actions/loading";
import { getApplicationMeetings } from "../../../../actions/applications";
import { setAlertAction } from "../../../../actions/alerts";
import { useTranslation } from "react-i18next";

interface MeetingAcceptConfirmDialogProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  // setMeetingDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  meetingDateAndTime?: {
    date?: string;
    time?: string;
    showDate?: string;
    showTime?: string;
  };
}

const MeetingAcceptConfirmDialog = ({
  open,
  // setMeetingDialogOpen,
  setOpen,
  meetingDateAndTime,
}: MeetingAcceptConfirmDialogProps) => {
  const dispatch = useDispatch();
  const [t] = useTranslation("lang", { useSuspense: false });
  const params: { id: string } = useParams();
  const { application, subEventApplication } = useSelector(
    (state: AppState) => state.applications
  );

  const onClose = () => {
    setOpen(false);
  };

  const onClickConfirm = async () => {
    if (subEventApplication.id && application.id && meetingDateAndTime) {
      const meetingStartEndTime = meetingDateAndTime?.time?.split("~"); // meetingId를 위한 split
      // 미팅신청 data
      const meetingData: MeetingApplicantDataInterface = {
        subEventId: params.id,
        applicant: subEventApplication.id!,
        acceptor: application.id,
        meetingId: `${meetingDateAndTime.date}${meetingStartEndTime![0]}${
          meetingStartEndTime![1]
        }`.trim(),
        status: "waiting",
        mailPostToggleAt: "true",
        date: meetingDateAndTime.date!,
        startTime: meetingStartEndTime![0].trim(),
        endTime: meetingStartEndTime![1].trim(),
      };
      setOpen(false);
      // setMeetingDialogOpen(false);
      dispatch(setLoadingAction());
      const result: any = await dispatch(applicationMeeting(meetingData));
      if (result) {
        // await dispatch(
        //   getApplicationMeeting({
        //     myApplicationId: subEventApplication.id,
        //     otherApplicationId: application.id,
        //   })
        // );
        await dispatch(
          getApplicationMeetings(application.id, subEventApplication.id)
        );
        dispatch(
          setAlertAction({
            id: "meetingConfirmed",
            msg: t("meetingAcceptConfirmDialog.doneDialog"),
            alertType: "success",
          })
        );
      }
      dispatch(removeLoadingAction());
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("meetingAcceptConfirmDialog.meetingApply")}</DialogTitle>
      <DialogContent>
        <Body1Typo>
          {t("meetingAcceptConfirmDialog.company")}: {application.name}
        </Body1Typo>
        <Body1Typo>
          {t("meetingAcceptConfirmDialog.date")}:{" "}
          {`${meetingDateAndTime?.showDate} ${meetingDateAndTime?.showTime}`}
          {/* {`${meetingDateAndTime?.date} ${meetingDateAndTime?.time}(GMT+9)`} */}
        </Body1Typo>
      </DialogContent>
      <DialogActions>
        <PxButton disableElevation onClick={onClose}>
          <ButtonTypo>{t("meetingAcceptConfirmDialog.cancel")}</ButtonTypo>
        </PxButton>
        <PxButton
          disableElevation
          backgroundcolor="purple"
          onClick={onClickConfirm}
        >
          <ButtonTypo>{t("meetingAcceptConfirmDialog.confirm")}</ButtonTypo>
        </PxButton>
      </DialogActions>
    </Dialog>
  );
};

export default MeetingAcceptConfirmDialog;
